<script setup lang="ts">
import { useSearchStore } from "@/stores/search";
import { t } from "@/services/i18n";
import { deleteSearchParam } from "@/lib/url/pushUrlSearchParams";

const store = useSearchStore();

function closeOverlay() {
    store.closeRestoreModal();
    deleteSearchParam("restore");
}
</script>
<template>
    <div class="[ c-modal__mask ]">
        <div class="[ c-modal__close ]" @click="closeOverlay"></div>
        <div
            class="[ c-modal__content c-modal__content--wide ] [ u-text-align-center ]"
        >
            <div class="[ c-modal__btn-close ]" @click="closeOverlay">
                <i class="[ c-icon c-icon--large ] [ icon icon-close ]"></i>
            </div>
            <h4 class="[ c-modal__headline ]">
                {{ t("info_modal_title") }}
            </h4>
            <!-- eslint-disable vue/no-v-html -->
            <p v-html="t('info_modal_text')"></p>
            <!-- eslint-disable vue/no-v-html -->
            <button class="[ c-btn ]" @click="closeOverlay">
                {{ t("info_modal_button") }}
            </button>
        </div>
    </div>
</template>
